import { Heading } from "@chakra-ui/react";
import MaslekaForm from "../components/maslekaForm";
import { useEffect, useState } from "react";
import api from "../services/api";
import { useParams } from "react-router-dom";


export default function MaslekaFr({ initData }) {

  const { guid } = useParams();

  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const resp = await api.epGetOrganizationData(guid);
        if (resp.status === 200) {
          resp.data.price = 0;
          setInitialData(resp.data);
          initData(resp.data);
         
          
        }
      } catch (error) {
        console.log(error);
      }
    }
    getData();
  }, [guid]);

  return (
    <>
      <Heading as="h1" variant={"h1"}>קבלת קוד אימות מהמסלקה הפנסיונית / הר הביטוח</Heading>
      <MaslekaForm initialData={initialData} />
    </>

  )
}